import { riyadaApi } from "../contants";
export const isRiyadaCustomer = ({ crNumber }: { crNumber: number }) => {
	return {
		url: `${riyadaApi}${crNumber}`,
		method: 'GET',
	};
};
